export const MAX_DATE_RANGE_DAYS = 90;

/** Converts an ISO datetime string to a YYYY-MM-DD date string for use in date inputs. */
export function toDateStr(isoString: string): string {
  return new Date(isoString).toISOString().substring(0, 10);
}

export function formatDateForDisplay(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export interface DateRangeErrorMessages {
  endRequired: string;
  startRequired: string;
  startBeforeEnd: string;
  exceedsMaxDays: string;
  exceedsAvailableData: string;
}

export function getDateRangeError(
  from: string,
  to: string,
  messages: DateRangeErrorMessages,
  maxDate?: string
): string | null {
  if (!from && !to) return null;
  if (from && !to) return messages.endRequired;
  if (!from && to) return messages.startRequired;

  const fromDate = new Date(from);
  const toDate = new Date(to);

  if (fromDate > toDate) return messages.startBeforeEnd;

  const diffDays =
    (toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24);
  if (diffDays > MAX_DATE_RANGE_DAYS) return messages.exceedsMaxDays;

  if (maxDate && to > maxDate) return messages.exceedsAvailableData;

  return null;
}
